// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"blueprint-icons-split-paths-by-size-loader","672":"blueprint-icons-16px-paths","783":"blueprint-icons-20px-paths","824":"blueprint-icons-all-paths-loader","860":"blueprint-icons-all-paths"}[chunkId] + "-" + __webpack_require__.h() + ".js";
};